import { Mail } from "lucide-react";
import { LegalLayout } from "@/components/LegalLayout";
import { LEGAL } from "@/legal/config";

const faqs = [
  ["How do I send an invoice?", "Add a client with their standard service and price. When the job is done, open Clients, tap SEND INVOICE NOW → Email Now. The PDF goes to the client's email instantly."],
  ["What is a draft?", "A running tab for bi-weekly or monthly billing. Tap Save Draft on the first visit, then \"Add Today's Charge\" on later visits. Email it whenever you're ready — it's dated the day you send it."],
  ["The email didn't arrive.", "Check the client's email address for typos (Settings → Clients → edit). Ask the client to check spam for a message from invoices@basta10.com. You can always download the PDF and send it yourself."],
  ["How do I mark an invoice paid?", "On Reports, tap the circle on the invoice row, or open the invoice and tap Mark Paid. You can email a receipt at the same time."],
  ["Can I change my logo, tax rate or invoice numbering?", "Yes — all of it is under Settings."],
  ["How do I cancel or change my plan?", "Settings → Subscription → Manage plan takes you to the billing portal where you can switch monthly/yearly, update your card, or cancel."],
  ["How do I delete my account?", "Settings → Delete account. This permanently removes your data and cancels your subscription. You can also email us from your account address and we'll do it for you."],
];

export default function SupportPage() {
  return (
    <LegalLayout title="Support" subtitle="We're a small team and we answer every email." testId="support-page">
      <section className="surface p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="h-12 w-12 rounded-full bg-emerald-50 dark:bg-emerald-950/50 grid place-items-center shrink-0"><Mail className="h-6 w-6 text-emerald-600" /></div>
        <div className="min-w-0">
          <div className="font-semibold">Email us</div>
          <a href={`mailto:${LEGAL.supportEmail}?subject=Basta10%20support`} className="break-all" data-testid="support-email-link">{LEGAL.supportEmail}</a>
          <p className="text-sm text-muted-foreground mt-1">Include the email you signed up with. Typical reply time: within one business day.</p>
        </div>
      </section>
      <section>
        <h2>Frequently asked questions</h2>
        <div className="divide-y divide-border surface">
          {faqs.map(([q, a]) => (
            <details key={q} className="group p-4">
              <summary className="cursor-pointer font-semibold list-none flex items-center justify-between gap-3">{q}<span className="text-muted-foreground group-open:rotate-45 transition-transform">+</span></summary>
              <p className="mt-2 text-sm">{a}</p>
            </details>
          ))}
        </div>
      </section>
      <section>
        <h2>Account deletion</h2>
        <p>Sign in → <b>Settings → Delete account</b>. Enter your password to confirm. All clients, invoices, expenses, receipt photos and your logo are permanently deleted and any active subscription is cancelled immediately. Prefer we do it? Email <a href={`mailto:${LEGAL.supportEmail}?subject=Delete%20my%20Basta10%20account`}>{LEGAL.supportEmail}</a> from your account address.</p>
      </section>
      <section>
        <h2>Legal</h2>
        <p><a href="/privacy">Privacy Policy</a> · <a href="/terms">Terms of Service</a></p>
      </section>
    </LegalLayout>
  );
}
